var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "container-listagem" },
      [
        _c("app-divider", {
          staticClass: "margin-bottom",
          attrs: { label: "Filtro:" }
        }),
        _c(
          "el-card",
          { staticClass: "card-container", attrs: { shadow: "hover" } },
          [
            _c("filtro", {
              attrs: {
                showOs: false,
                showMunicipios: false,
                configuracaoFiltro: _vm.configuracaoFiltro,
                filtroRapido: _vm.filtroRapido
              },
              on: { pesquisar: _vm.pesquisar, limpar: _vm.clear }
            })
          ],
          1
        ),
        _c("app-divider", {
          staticClass: "margin-bottom",
          attrs: { label: "Laudos:" }
        }),
        _c("app-listagem", {
          attrs: {
            "has-refresh-button": true,
            "json-headers": _vm.colunas,
            "json-data": _vm.laudos,
            totalElements: _vm.totalElements,
            pagina: _vm.filtro.pagina,
            filtro: _vm.filtro
          },
          on: {
            atualizarFiltro: _vm.atualizarFiltro,
            updateListagem: _vm.findProcessos,
            changePage: _vm.changePage,
            sort: _vm.sort,
            executar: _vm.executar
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57368c18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57368c18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/diagnostico/Listagem.vue
// module id = null
// module chunks = 